import { IProps as IImage } from 'marketing-site/src/library/elements/Image'
import { AllSystemColors } from '../../utils'
import { ICTAData } from '../CTALink'
import { IProps as IModalButton } from '../ModalButton'

export { SolutionCard } from './element'

export interface IProps {
  contentType?: string
  cursiveTitle?: string
  title: string
  body: string | undefined
  staticImage: IImage
  animatedImage?: IImage
  cta?: ICTAData | IModalButton
  cardColor: AllSystemColors
  icon?: string
  borderColor?: AllSystemColors
  type?: 'default' | 'with-header' | 'compact'
}
